import { z } from 'zod';

export const OTP_CHANNEL_ERROR_CODES = {
  ALTERNATE_EMAIL_REQUIRED_FOR_2FA: 'ALTERNATE_EMAIL_REQUIRED_FOR_2FA',
  OTP_EMAILS_SUPPRESSED: 'OTP_EMAILS_SUPPRESSED',
} as const;

export const ZodOtpChannel = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('sms'),
    phoneNumber: z.string(),
    isLandlinePhoneNumber: z.boolean(),
  }),
  z.object({
    type: z.literal('alternate_email'),
    email: z.string(),
  }),
  z.object({
    type: z.literal('primary_email'),
    email: z.string(),
  }),
  z.object({
    type: z.literal('unavailable'),
    reason: z.enum([
      OTP_CHANNEL_ERROR_CODES.ALTERNATE_EMAIL_REQUIRED_FOR_2FA,
      OTP_CHANNEL_ERROR_CODES.OTP_EMAILS_SUPPRESSED,
    ]),
  }),
]);

export type OtpChannel = z.infer<typeof ZodOtpChannel>;
